import { generator } from '../event-listener.js';
export const OnBlur = generator('onBlur');
export const OnFocus = generator('onFocus');
//# sourceMappingURL=focusable.js.map